import { Tooltip } from "primereact/tooltip";
import React from "react";
import { TFunction } from "i18next";

export const inspectionDueDateOnlyCellTemplate = (
    inspectionDueDate: Date,
    t: TFunction
) => {
    const formattedScheduledDate =
        inspectionDueDate.toLocaleDateString("en-GB");
    const today = new Date();

    const showOverdue = inspectionDueDate < today;

    const getTranslationText = (key: string) => t(key);

    return (
        <React.Fragment>
            <div className="inspection-due-cell">
                <span className={showOverdue ? "text-danger" : ""}>
                    {formattedScheduledDate}
                </span>
                {showOverdue ? (
                    <p className={"overdue-text text-danger"}>
                        {getTranslationText("fleetTable.overdue")}
                    </p>
                ) : (
                    <></>
                )}
            </div>
        </React.Fragment>
    );
};

export const inspectionDueDateWithCalendarCellTemplate = (rowData: any) => {
    let dateString = "";
    if (rowData.inspection.dateTo) {
        dateString = `${new Date(
            rowData.inspection.dateFrom
        ).toLocaleDateString("en-GB")} - ${new Date(
            rowData.inspection.dateTo
        ).toLocaleDateString("en-GB")}`;
    } else {
        dateString = new Date(rowData.inspection.dateFrom).toLocaleDateString(
            "en-GB"
        );
    }

    return (
        <React.Fragment>
            <div className="flex align-items-center">
                <div className="inspection-due-cell">
                    <span className="inspection-due-date">{dateString}</span>
                    <small className="inspection-due-location">
                        {rowData.inspection.location.name +
                            ", " +
                            rowData.inspection.location.country.name}
                    </small>
                </div>
                <Tooltip
                    target=".inspection-due-calendar"
                    position="bottom"
                ></Tooltip>
                <i
                    className="pi pi-calendar inspection-due-calendar ml-2"
                    data-pr-tooltip="Inspection ordered"
                ></i>
            </div>
        </React.Fragment>
    );
};
